<template>
  <b-row>
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
    <b-col md="12">
      <b-card>
        <div slot="header">
          <strong>Ações sobre Usuários em Lote</strong>
        </div>
        <b-form @submit.stop.prevent>
          
          <b-form-group label="CPF/CNPJ" label-for="usernames" description="Informe a lista de CPF ou CNPJ separados por vírgula ou espaço.">
            <b-form-textarea id="usernames" v-model="usernamesStr" rows="3"></b-form-textarea>
          </b-form-group>

          <div v-if="errors.length">
            <b-alert show variant="warning"><strong>Erros:</strong>
              <ul>
                <li v-for="itm in errors" :key="itm.username">
                  <strong>{{ itm.username }}: </strong> {{ itm.detail.detail }}
                </li>
              </ul>
            </b-alert>
          </div>

          <div slot="footer">
            <b-row>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="danger" @click="executeConfirm(action.remove)"><i class="fa fa-trash"></i> Remover</b-button>&nbsp;
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="warning" @click="executeConfirm(action.lock)"><i class="fa fa-lock"></i> Bloquear</b-button>&nbsp;
              </b-col>
              <b-col sm="12" lg="2">
                <b-button class="form-control" type="button" variant="info" @click="executeConfirm(action.unlock)"><i class="fa fa-unlock"></i> Desbloquear</b-button>&nbsp;
              </b-col>
            </b-row>
          </div>
        </b-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import axios from 'axios';
import { requestError, env } from '@/shared/utils';
import { request } from 'http';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
  components: {
    Loading
  },
  data: () => {
    return {
      usernamesStr: "",
      errors: [],
      usernamesNotFound: [],
      loadCount: 0,
      action: {
        unlock: 0,
        lock: 2,
        remove: 4,
      }
    }
  },
  computed: {
    isLoading() {
      return this.loadCount > 0;
    }
  },
  methods: {
    actionName(status) {
      switch (status) {
        case this.action.remove:
          return "remover";
        case this.action.lock:
          return "bloquear";
        case this.action.unlock:
          return "desbloquear";
        default:
          return null;
      }
    },
    executeConfirm(status) {
      if (!this.usernamesStr) {
        this.$bvModal.msgBoxOk('A lista de usuários deve ser preenchida')
          .then(value => {})
          .catch(console.error);
      } else {
        this.$bvModal.msgBoxConfirm(`Deseja realmente ${this.actionName(status)} os usuários informados?`)
          .then(val => {
            val && this.execute(status);
          }).catch(console.error);
      }
    },
    execute(status) {
      this.loadCount++;
      let usernames = this.usernamesStr.split(/[\s,]+/);
      this.errors = [];
      let data = {
        status,
        usernames
      }
      axios
        .patch(`${env.urlBillingApi}/corporation-user`, { data })
        .then((response) => {
          this.errors = response.data._embedded.corporation_user[0].errors;
          console.log(this.errors);
          if (this.errors.length == 0) {
            this.$bvModal.msgBoxOk('Ação realizada com sucesso!')
              .then(value => {})
              .catch(console.error);
          } else {
            this.$bvModal.msgBoxOk('Ocorreram alguns problemas ao realizar a ação!')
              .then(value => {})
              .catch(console.error);
          }
        })
        .catch((error) => {
          requestError(error);
        })
        .finally(() => {
          this.loadCount--;
        });
    }
  }
}
</script>
